import { OAuthStorage } from 'angular-oauth2-oidc';

export function shouldUseSharedOAuthStorage(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function oauthStorageFactory(): OAuthStorage {
  if (shouldUseSharedOAuthStorage()) {
    return localStorage;
  }

  return sessionStorage;
}
